import { render } from "./SinistroAprovacaoDetalheView.vue?vue&type=template&id=52b4c8fb&scoped=true"
import script from "./SinistroAprovacaoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroAprovacaoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroAprovacaoDetalheView.vue?vue&type=style&index=0&id=52b4c8fb&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b4c8fb"]])

export default __exports__